import Icon from "../base/Icon"

interface IProps {
    onJobAndPick?: () => void
    onEveryone?: () => void
    /** Whether the traffic layer is on; the button is there only when onTraffic is given. */
    traffic?: boolean
    onTraffic?: () => void
    /** Whether the metros' areas are shown; the button is there only when onMetros is given. */
    metros?: boolean
    onMetros?: () => void
}

/** The views of a map for giving a job a technician, and the metros and traffic switches, in a row along its bottom left. */
export default function JobTechsMapControls(props: IProps) {
    return (
        <div className="base-map-controls is-bottom">
            {
                props.onJobAndPick &&
                <button type="button" className="btn btn-sm btn-icon btn-light" title="Job and picked technician" onClick={props.onJobAndPick}>
                    <Icon icon="location-crosshairs" />
                </button>
            }
            {
                props.onEveryone &&
                <button type="button" className="btn btn-sm btn-icon btn-light" title="Show all technicians" onClick={props.onEveryone}>
                    <Icon icon="users" />
                </button>
            }
            {
                props.onMetros &&
                <button type="button" className={"btn btn-sm btn-icon " + (props.metros ? "btn-primary" : "btn-light")}
                    title={props.metros ? "Hide metros" : "Show metros"} onClick={props.onMetros}>
                    <Icon icon="draw-polygon" />
                </button>
            }
            {
                props.onTraffic &&
                <button type="button" className={"btn btn-sm btn-icon " + (props.traffic ? "btn-primary" : "btn-light")}
                    title={props.traffic ? "Hide traffic" : "Show traffic"} onClick={props.onTraffic}>
                    <Icon icon="traffic-light" />
                </button>
            }
        </div>
    )
}
